import { ROUTEMAP } from '@/components/fakeDoor/constants';
import { BookingType } from '@/components/fakeDoor/types';
import { formatDate } from '@/utils/formatters';
import { IVR_DATA } from '@/constants';
import { APPOINTMENT_CARD_TYPE } from '@/constants/enums';

export const appointmentCardFields: Record<
    APPOINTMENT_CARD_TYPE,
    (appointmentDetails: any) => any
> = {
    [APPOINTMENT_CARD_TYPE.VIEW_BOOKING]: (appointmentDetails: any) => ({
        ctaName: 'View Booking Details',
        cardText: `Your booking is confirmed for ${formatDate(appointmentDetails.booking_details?.appointment_date)}`,
        navigatePath: `${ROUTEMAP.GARAGE_APPOINTMENT_CONFIRMATION}?appointmentId=${appointmentDetails.appointment_id}&garageId=${appointmentDetails.garage_id}&hide_app_bar=true`,
        cardName: 'Upcoming Booking',
        cardType: APPOINTMENT_CARD_TYPE.VIEW_BOOKING,
    }),
    [APPOINTMENT_CARD_TYPE.RESUME_BOOKING]: (appointmentDetails: any) => ({
        ctaName: 'Resume Booking',
        cardText: 'Complete Your booking today',
        navigatePath: `${ROUTEMAP.ADDRESS_SELECTION}?appointmentId=${appointmentDetails.appointment_id}&slot_type=${appointmentDetails.booking_details?.appointment_fulfillment_type || BookingType.PICK_AND_DROP}&garageId=${appointmentDetails.garage_id}&hide_app_bar=true`,
        cardName: 'Resume address',
        cardType: APPOINTMENT_CARD_TYPE.RESUME_BOOKING,
    }),
    [APPOINTMENT_CARD_TYPE.SELECT_SLOT]: (appointmentDetails: any) => {
        let navigatePath = `${ROUTEMAP.SLOT_SELECTION}?appointmentId=${appointmentDetails.appointment_id}&slot_type=${appointmentDetails.booking_details?.appointment_fulfillment_type}&garageId=${appointmentDetails.garage_id}&hide_app_bar=true`;
        if (
            appointmentDetails.booking_details?.appointment_fulfillment_type ===
            BookingType.PICK_AND_DROP
        ) {
            navigatePath += `&pincode=${appointmentDetails?.pickup_details?.address?.pincode || ''}`;
        }
        return {
            ctaName: 'Select slot',
            cardText: `You're almost there! Select your service slot to complete your booking`,
            navigatePath,
            cardName: 'Resume Slot',
            cardType: APPOINTMENT_CARD_TYPE.SELECT_SLOT,
        };
    },
    [APPOINTMENT_CARD_TYPE.COMPLETE_PAYMENT]: (appointmentDetails: any) => ({
        ctaName: 'Complete Payment',
        paymentLink: appointmentDetails.payment_details?.payin_url,
        cardText: 'Complete your payment to confirm your service appointment',
        navigatePath: appointmentDetails.payment_details?.payin_url,
        cardName: 'Resume Payment',
        cardType: APPOINTMENT_CARD_TYPE.COMPLETE_PAYMENT,
    }),
    [APPOINTMENT_CARD_TYPE.CONTACT_US]: () => ({
        ctaName: 'Contact Us',
        cardText: `There's a slight delay from our payment partner. We're working on it and will update you soon.`,
        navigatePath: `tel:${IVR_DATA.SERVICE_ADVISOR_NUMBER}`,
        cardName: 'Payment Pending',
        cardType: APPOINTMENT_CARD_TYPE.CONTACT_US,
    }),
};
